import React from 'react';
import { useTranslation } from 'react-i18next';
import { Budget, Transaction } from '../types/budget';
import { formatCurrency } from '../utils/budget';

interface TransactionTableFooterProps {
  transactions: Transaction[];
  budget?: Budget;
}

export const TransactionTableFooter: React.FC<TransactionTableFooterProps> = ({
  transactions,
  budget,
}) => {
  const { t } = useTranslation();
  const total = transactions.reduce((acc, t) => acc + t.amount, 0);

  return (
    <tfoot className="bg-slate-50 dark:bg-surface-800">
      <tr>
        <td
          className="px-6 py-4 text-sm font-medium text-slate-900 dark:text-slate-300 lg:hidden"
          colSpan={2}
        >
          {t('transaction.total')}
        </td>
        <td
          className="hidden px-6 py-4 text-sm font-medium text-slate-900 dark:text-slate-300 lg:table-cell"
          colSpan={4}
        >
          {t('transaction.total')}
        </td>
        <td
          className={`whitespace-nowrap px-6 py-4 text-right text-sm font-bold ${
            total >= 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'
          }`}
        >
          {formatCurrency(total, budget?.settings?.currency)}
        </td>
        <td></td>
      </tr>
    </tfoot>
  );
};
